import type { GeoJsonData } from '../../../../app-kit/components/PcaMap/PcaMap';
import { addGeoJson } from '../../../../app-kit/components/PcaMap/helpers/addGeoJson';

export const addPropertyMapGeoJson = (
  map: google.maps.Map,
  propertyBoundary?: GeoJsonData | null,
  buildingBoundaries?: GeoJsonData | null,
) => {
  // overlay is used to hide googles building estimation
  if (propertyBoundary && buildingBoundaries)
    addGeoJson(map, propertyBoundary, 'mapBackgroundOverlay');
  if (propertyBoundary) addGeoJson(map, propertyBoundary, 'propertyBoundary');
  if (buildingBoundaries) addGeoJson(map, buildingBoundaries, 'buildingBoundary');
};
